<template>
  <main class="mt-3">
    <div class="card shadow-none border">
      <div class="card-header font-weight-bold d-flex align-items-center justify-content-between">
        <span><i class="fas fa-allergies text-info mr-2"></i>Alergias e Intolerancias (RDA Consulta)</span>
      </div>
      <div class="card-body">
        <AllergyDetail
          v-model="itemsForm"
          @input="onAllergiesChange"
        />

        <div class="mt-3" v-if="alergiasGuardadas.length > 0">
          <label class="font-weight-bold small text-secondary">Alergias Registradas del Paciente</label>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th style="width: 140px;">Tipo</th>
                  <th>Alergia (Concepto)</th>
                  <th>Reacción</th>
                  <th style="width: 140px;">Origen</th>
                  <th class="text-center" style="width: 60px;">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in alergiasGuardadas" :key="item.id">
                  <td><span class="badge badge-info">{{ tipoLabel(item.tipo) }}</span></td>
                  <td class="font-weight-bold">{{ item.concepto }}</td>
                  <td>{{ item.reaccion || 'N/A' }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="item.id_historia == idHistoria ? 'badge-success-soft text-success border border-success' : 'badge-light text-muted border'"
                    >
                      {{ item.id_historia == idHistoria ? 'Atención Actual' : 'Histórico' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-xs btn-outline-danger border-0"
                      title="Eliminar"
                      @click="eliminarAlergia(item.id)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AllergyDetail from "@/components/antecedentes/AllergyDetail.vue";
import alergiaUsuarioService from "@/services/alergiaUsuarioService";
import Toast from "@/components/common/utilities/toast";

const TIPOS = {
  '01': 'Medicamento',
  '02': 'Alimento',
  '03': 'Ambiental',
  '04': 'Sustancias que entran en contacto con la piel',
  '05': 'Picadura de insectos',
  '06': 'Otra'
};

export default {
  name: "AlergiasComponent",
  components: {
    AllergyDetail
  },
  props: {
    idHistoria: {
      type: [Number, String],
      default: null
    },
    idUsuario: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      itemsForm: [],
      alergiasGuardadas: [],
      cargando: false
    };
  },
  methods: {
    tipoLabel(code) {
      return TIPOS[code] || code || 'N/A';
    },
    async cargarAlergias() {
      if (!this.idUsuario) return;
      try {
        const res = await alergiaUsuarioService.getByUsuario(this.idUsuario);
        if (res.data && res.data.status === "ok") {
          this.alergiasGuardadas = res.data.data || [];
        }
      } catch (e) {
        console.error("Error al cargar alergias del usuario:", e);
      }
    },
    async onAllergiesChange(newList) {
      if (!newList || newList.length === 0) return;
      const lastItem = newList[newList.length - 1];

      try {
        const payload = {
          usuario_antecedente_id: null,
          id_historia: this.idHistoria || null,
          id_usuario: this.idUsuario,
          tipo: lastItem.tipo,
          concepto: lastItem.concepto,
          reaccion: lastItem.reaccion || null
        };

        const res = await alergiaUsuarioService.store(payload);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Alergia registrada"
          });
          this.itemsForm = [];
          await this.cargarAlergias();
        }
      } catch (e) {
        console.error("Error al guardar alergia:", e);
        Toast.fire({
          icon: "error",
          title: "Error al guardar la alergia"
        });
      }
    },
    async eliminarAlergia(id) {
      try {
        const res = await alergiaUsuarioService.delete(id);
        if (res.data && res.data.status === "ok") {
          Toast.fire({
            icon: "success",
            title: "Alergia eliminada"
          });
          await this.cargarAlergias();
        }
      } catch (e) {
        console.error("Error al eliminar alergia:", e);
      }
    }
  },
  watch: {
    idUsuario: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cargarAlergias();
        }
      }
    }
  }
};
</script>
